import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import {
  modalButtonsSectionStyle,
  modalContentContainerStyle,
} from '@components/Modal/ModalContainer';
import { IShopModal } from '@components/Modal/types';

const DeleteShopModal = ({ shop, closeModal, handleSubmit }: IShopModal) => {
  return (
    <>
      <Box sx={modalContentContainerStyle}>
        <Typography id="modal-modal-title" variant="h6" component="h2">
          Delete shop
        </Typography>
      </Box>
      <Box sx={{ textAlign: 'center', marginBottom: '48px' }}>
        <Typography id="modal-modal-title" variant="h6" component="h2">
          {`Are you sure you want to delete shop ${shop?.name}?`}
        </Typography>
      </Box>
      <Box sx={modalButtonsSectionStyle}>
        <Button size="large" variant="text" onClick={closeModal}>
          Cancel
        </Button>
        <Button onClick={handleSubmit.bind(null, shop?.id)} size="large" variant="contained">
          Delete shop
        </Button>
      </Box>
    </>
  );
};

export default DeleteShopModal;
